import { Icon } from './ui/Icon';
import { formatDate } from '../utils/format';
import type { PostSummary } from '../types';
import { t } from '../i18n/t';

export interface BlogCardProps {
  post: PostSummary;
}

export function BlogCard({ post }: BlogCardProps) {
  return (
    <li className="h-full">
      <article className="flex h-full flex-col rounded-2xl bg-white p-6 transition duration-300 hover:bg-secondary-50/60 sm:p-7">
        {post.category && (
          <a
            href={post.category.path}
            className="self-start text-xs font-semibold uppercase tracking-wide text-secondary-600 hover:text-secondary-700"
          >
            {post.category.name}
          </a>
        )}

        <h3 className="mt-3 font-display text-lg font-semibold leading-snug tracking-tight text-primary-500">
          <a href={post.path} className="hover:text-secondary-700">
            {post.title}
          </a>
        </h3>

        <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>

        <div className="mt-5 flex items-center gap-3 text-xs text-slate-500">
          <time dateTime={post.publishedAt}>{formatDate(post.publishedAt)}</time>
          <span aria-hidden="true">·</span>
          <span className="inline-flex items-center gap-1">
            <Icon name="clock" className="h-3.5 w-3.5" />
            {t('ui.blog.reading_time', { count: post.readingMinutes })}
          </span>
        </div>
      </article>
    </li>
  );
}

export function BlogCardGrid({ posts }: { posts: PostSummary[] }) {
  return (
    <ul className="grid gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3">
      {posts.map((post) => (
        <BlogCard key={post.slug} post={post} />
      ))}
    </ul>
  );
}
